import { DEFAULT_FORMAT_DATE } from "constants/datetime";
import { RequestStatusSearchSelect } from "constants/enumSelect/requestSelect";

import { Box, Grid } from "@mui/material";
import {
  DateRangePickerHookForm,
  DayjsLocalizationProvider,
  FormContainerControlled,
  SelectHookForm,
  TextFieldHookForm,
} from "components";
import { ButtonApply } from "components/ButtonApply/ButtonApply";
import ClientSelectForm from "components/SelectApi/ClientSelectForm";
import UserSelectForm from "components/SelectApi/UserSelectForm";
import { dayjsTZ } from "helpers";
import { useForm } from "react-hook-form";

interface FilterProps {
  data?: any;
  onSearch?: (value: any) => void;
}

export const RequestFilter = (props: FilterProps) => {
  const { data, onSearch } = props;
  const methods = useForm<any>({
    values: {
      reportCodeOrName: data?.checklistCodeOrName ?? "",
      client:
        data?.clientName &&
        data?.clientName?.length &&
        data?.clientId &&
        data?.clientId?.length
          ? // eslint-disable-next-line
            data?.clientId?.map((e: any, i: number) => {
              return {
                value: e,
                label: data?.clientName[i],
              };
            })
          : undefined,
      personInCharge:
        data?.picName &&
        data?.picName?.length &&
        data?.picId &&
        data?.picId?.length
          ? // eslint-disable-next-line
            data?.picId?.map((e: any, i: number) => {
              return {
                value: e,
                label: data?.picName[i],
              };
            })
          : undefined,
      picName: data?.picName ?? undefined,
      picId: data?.picId ?? undefined,
      createdAt:
        data?.createdAt && data?.createdAt?.length > 0
          ? // eslint-disable-next-line
            data?.createdAt?.map((e: string) => {
              if (e) {
                return dayjsTZ(e);
              }
              return null;
            })
          : [null, null],
      dueDate:
        data?.dueDate && data?.dueDate?.length > 0
          ? // eslint-disable-next-line
            data?.dueDate?.map((e: string) => {
              if (e) {
                return dayjsTZ(e);
              }
              return null;
            })
          : [null, null],
      status: data?.status ?? "All",
    },
  });
  const { watch } = methods;
  const onSubmit = () => {
    if (onSearch !== undefined) {
      onSearch({
        ...data,
        ...watch(),
        // eslint-disable-next-line
        picId: watch("personInCharge")?.map((e: any) => e?.value),
        // eslint-disable-next-line
        picName: watch("personInCharge")?.map((e: any) => e?.label),
        personInCharge: undefined,
        client: undefined,
        // eslint-disable-next-line
        clientId: watch("client")?.map((e: any) => e?.value),
        // eslint-disable-next-line
        clientName: watch("client")?.map((e: any) => e?.label),
      });
    }
  };

  return (
    <FormContainerControlled methods={methods} onSubmit={onSubmit}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid container spacing="14px" marginTop="0">
          <Grid item xs={12} lg={4}>
            <TextFieldHookForm
              name="reportCodeOrName"
              label="Checklist Code/Name"
              placeholder="Enter to search"
            />
          </Grid>

          <Grid item xs={12} lg={4}>
            <ClientSelectForm
              name="client"
              label="Contractor"
              placeholder="Select option(s)"
              multi
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <UserSelectForm
              name="personInCharge"
              label="Person in Charge"
              multi
              placeholder="Select option(s)"
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <DayjsLocalizationProvider>
              <DateRangePickerHookForm
                format={DEFAULT_FORMAT_DATE}
                name="createdAt"
                label="Assigned Date"
                placeholder="Select date"
              />
            </DayjsLocalizationProvider>
          </Grid>
          <Grid item xs={12} lg={4}>
            <DayjsLocalizationProvider>
              <DateRangePickerHookForm
                format={DEFAULT_FORMAT_DATE}
                name="dueDate"
                label="Due Date"
                placeholder="Select date"
              />
            </DayjsLocalizationProvider>
          </Grid>
          <Grid item xs={12} lg={4}>
            <SelectHookForm
              name="status"
              label="Status"
              placeholder="Select an option"
              options={RequestStatusSearchSelect}
            />
          </Grid>
        </Grid>

        <ButtonApply />
      </Box>
    </FormContainerControlled>
  );
};
